const messages = {
  title: "Bienvenue sur BRIDGESTONE <span class='text-danger'>PLUS</span>",
  description:
    "Connectez-vous à l'aide de votre adresse e-mail et de votre mot de passe.<br/></br><b>Vous êtes nouveau ici?</b><br/></br>Créez ensuite votre nouveau compte d'utilisateur en utilisant la fonction ENREGISTREMENT.<br/></br>Vous serez alors automatiquement connecté.",
  info: "",
  buttons: {
    action: "S'identifier / S'inscrire",
    back: "Retour à la connexion",
    changeLanguage: "Changer de langue",
    start: "Commencer",
  },
  languageSelect: {
    label: "Sélection de la langue",
    description: "Veuillez choisir votre langue",
    start: {
      deCH: "Allemand",
      frCH: "Français",
      itCH: "Italien",
    },
  },
};

export default {
  messages,
};
